import React from 'react';
import PropTypes from 'prop-types';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';

const CustomModal = ({
  children,
  isOpen,
  onCloseHandler,
  closeOnOverlayClick,
  closeOnEsc,
  blockScroll,
  classNames,
  onOverlayClick,
}) => {
  return (
    <Modal
      open={isOpen}
      center
      onClose={onCloseHandler}
      showCloseIcon={false}
      closeOnOverlayClick={closeOnOverlayClick}
      onOverlayClick={onOverlayClick}
      closeOnEsc={closeOnEsc}
      blockScroll={blockScroll}
      classNames={{
        modal: `lf-modal ${classNames}`,
      }}
    >
      {children}
    </Modal>
  );
};
CustomModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.any.isRequired,
  onCloseHandler: PropTypes.func,
  closeOnOverlayClick: PropTypes.bool,
  closeOnEsc: PropTypes.bool,
  blockScroll: PropTypes.bool,
  classNames: PropTypes.string,
};

CustomModal.defaultProps = {
  onCloseHandler: () => {},
  onOverlayClick: () => {},
  closeOnOverlayClick: false,
  closeOnEsc: false,
  blockScroll: true,
  classNames: '',
};

export default CustomModal;
